import React, { memo } from 'react';

const ExcelIcon = ({ color = '#335B70' }) => {
    return (
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M18.813 4.75v22.5h11.163c.565 0 1.024-.439 1.024-.977V5.734c0-.544-.459-.984-1.024-.984H18.813z"
                    fill="#227547"
                />
                <path
                    fill="#FFF"
                    d="M18.813 7.563h3.833v2.813h-3.833zM18.813 12.25h3.833v2.813h-3.833zM18.813 16.938h3.833v2.813h-3.833zM18.813 21.625h3.833v2.813h-3.833zM24.438 21.625h3.75v2.813h-3.75zM24.438 16.938h3.75v2.813h-3.75zM24.438 12.25h3.75v2.813h-3.75zM24.438 7.563h3.75v2.813h-3.75z"
                />
                <path fill="#227547" d="M1 4.336v23.328L17.875 31V1z" />
                <path
                    fill="#FFF"
                    d="M9.236 14.063L11.74 9.76h2.39l-3.6 5.908 3.681 6.006h-2.414l-2.56-4.37-2.57 4.37H4.26l3.69-6.006L4.343 9.76h2.39z"
                />
            </g>
        </svg>
    );
};

export default memo(ExcelIcon);
